import * as Yup from "yup";

import {
  VeteranAutoProductDetailsFormValues,
  VeteranAutoProductPriceFormValues,
} from "../veteranAutoInterface";

import { validationObject as insuranceOwnerValidationObject } from "Components/Form/CommonFormElements/InsuranceOwnerFormElement/validation";
import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";

export const getIsMemberOfVeteranClubSchema = (): Yup.ObjectSchema<
  Pick<VeteranAutoProductPriceFormValues, "isMemberOfVeteranClub">
> => {
  const { getText } = TextManager;
  return Yup.object().shape({
    isMemberOfVeteranClub: Yup.mixed<BooleanFormType>().required(
      getText("veteranautoform.validation.ismemberofveteranclub"),
    ),
  });
};

export const validationSchema =
  (): Yup.ObjectSchema<VeteranAutoProductDetailsFormValues> =>
    Yup.object()
      .shape(insuranceOwnerValidationObject())
      .concat(getInjuriesSchema());
